<template>
  <div class="new-company-calculator" style="width: 100vw">
    <div class="columns is-centered">
      <div class="column">
        <b-field
          :label="$t('註冊資本')"
          :message="$t(validation.firstError('amount'))"
        >
          <p class="control">
            <b-button>MOP</b-button>
          </p>
          <b-input
            v-model="amount"
            :class="{ errorInput: validation.hasError('amount') }"
          ></b-input>
        </b-field>
        <p>{{ $t("register_capital_limit_25000") }}</p>
        <b-button
          @click="calculate"
          class="is-primary"
          style="background-color: #00775e"
          >{{ $t("calculate") }}</b-button
        >
      </div>
    </div>

    <div v-if="result" class="table-container">
      <table
        class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth"
      >
        <tbody>
          <tr>
            <th>{{ $t("notarization_fee") }}</th>
            <td class="has-text-right">
              {{ formatPrice(result.handlingFee) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t("notarial_stamp_duty_2021") }}</th>
            <td class="has-text-right">{{ formatPrice(result.stampTax) }}</td>
          </tr>
          <tr>
            <th>{{ $t("registration_certificate_fee") }}</th>
            <td class="has-text-right">
              {{ formatPrice(result.registerFee) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t("company_registration") }}</th>
            <td class="has-text-right">
              {{ formatPrice(result.registerCompanyFee) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t("main_cost_setup_company") }}</th>
            <td class="has-text-right">{{ formatPrice(result.total) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import SimpleVueValidation from "simple-vue-validator";
import numeral from "numeral";

const Validator = SimpleVueValidation.Validator;
export default {
  name: "NewCompanyCal",
  props: [],
  data() {
    return {
      amount: "",
      // handlingFee: "",
      // stampTax: "",
      // registerFee: 65,
      // registerCompanyFee: "",
      result: null,
    };
  },
  validators: {
    amount: function (value) {
      return Validator.value(value)
        .required()
        .integer()
        .greaterThanOrEqualTo(25000)
        .custom(function () {
          if (value % 100 !== 0) {
            return "simpleVueValidator_can_divided_by_100";
          }
        });
    },
  },
  methods: {
    calHandingFee(amount, ratio) {
      return Math.round((amount / 1000) * ratio);
    },

    calculate() {
      this.$validate().then((success) => {
        let handlingFee = 0;
        let stampTax;
        const registerFee = 65;
        let registerCompanyFee;
        let value = this.amount;

        if (success) {
          handlingFee = 100;
          if (value > 5000000) {
            // handlingFee = 1000;
            handlingFee = handlingFee + this.calHandingFee(value - 5000000, 1);
          } else {
            // handlingFee = 100;
          }

          if (value > 2000000) {
            if (value > 5000000) {
              handlingFee =
                handlingFee + this.calHandingFee(5000000 - 2000000, 2);
            } else {
              handlingFee =
                handlingFee + this.calHandingFee(value - 2000000, 2);
            }
          }

          if (value > 1000000) {
            if (value > 2000000) {
              handlingFee =
                handlingFee + this.calHandingFee(2000000 - 1000000, 3);
            } else {
              handlingFee =
                handlingFee + this.calHandingFee(value - 1000000, 3);
            }
          }

          if (value > 500000) {
            if (value > 1000000) {
              handlingFee =
                handlingFee + this.calHandingFee(1000000 - 500000, 4);
            } else {
              handlingFee = handlingFee + this.calHandingFee(value - 500000, 4);
            }
          }

          if (value <= 500000) {
            handlingFee = handlingFee + this.calHandingFee(value, 5);
          } else {
            handlingFee = handlingFee + this.calHandingFee(500000, 5);
          }

          stampTax = this.amount < 30000 ? 20 : 100;

          if (this.amount < 100000 || this.amount == 100000) {
            registerCompanyFee = 300;
          } else if (this.amount < 1000000 || this.amount == 1000000) {
            registerCompanyFee = 1000;
          } else {
            registerCompanyFee = 3000;
          }

          this.result = {
            handlingFee,
            stampTax,
            registerFee,
            registerCompanyFee,
            total: handlingFee + registerFee + stampTax + registerCompanyFee,
          };
        }
      });
    },
    formatPrice(price) {
      return "MOP " + numeral(price).format("0,0.00");
    },
  },
};
</script>
